
//Global CSS
import '@/assets/css/reset.scss'
import '@/assets/css/variables.scss'
import '@/assets/css/themes.scss'
import '@/assets/css/elements.scss'
import '@/assets/css/utility.scss'
import '@/assets/css/primevue.scss'

//Vue
import {createApp} from 'vue'
import {createPinia} from 'pinia'

//PrimeVue
import PrimeVue from 'primevue/config'

//Services
import {router} from '@/routing/router.js'
import {initSentry} from '@/services/sentry.js'
import {primeVueConfig} from '@/services/primevue.js'
import {useErrorHandling} from '@/composables/use-error-handling.js'

//Components
import App from './App.vue'
import Debug from '@/components/shared/dev/Debug.vue'

//Create app
const app = createApp(App)
const pinia = createPinia()

//Register plugins and services
app
  .use(pinia)
  .use(router)
  .use(PrimeVue, primeVueConfig)

//Register global components
app
  .component('Debug', Debug)

//Initialize Sentry
initSentry(app, router, pinia)

//Attach to Vue error handler
const {processError} = useErrorHandling()
app.config.errorHandler = processError

//Mount app
app
  .mount('#app')
